<template>
  <div v-if="isInfoShow" class="address-edit-container">
    <div class="address-edit-box">
      <button class="close-btn" @click="handleClose">
        <KyIcon type="close" size="18" color="#666" />
      </button>
      <div class="address-popup">
        <div class="popup-header">
          <h2 class="title">添加地址</h2>
        </div>

        <div class="form-container">
          <el-form
            :model="addressForm"
            class="recipient-form"
            label-position="left"
          >
            <el-form-item
              label="地区"
              class="form-item-with-line"
              :show-message="false"
              label-width="100px"
            >
              <el-cascader
                v-model="addressForm.city"
                :options="areaOptions"
                placeholder="选择地区"
                class="custom-input"
                @change="handleAreaChange"
                name="city"
              ></el-cascader>
              <p v-if="addressForm.errors.city" class="error-tip">
                {{ addressForm.errors.city }}
              </p>
            </el-form-item>

            <el-form-item
              label="详细地址"
              class="form-item-with-line"
              :show-message="false"
              label-width="100px"
            >
              <el-input
                v-model="addressForm.user_address"
                placeholder="填写详细地点名称和门牌号"
                class="custom-input"
                @input="handleAddressInput"
                name="user_address"
              ></el-input>
              <p v-if="addressForm.errors.user_address" class="error-tip">
                {{ addressForm.errors.user_address }}
              </p>
            </el-form-item>

            <!-- 姓名 -->
            <el-form-item
              label="姓名"
              class="form-item-with-line"
              :show-message="false"
              label-width="100px"
            >
              <el-input
                v-model="addressForm.user_name"
                placeholder="填写收货人姓名"
                maxlength="10"
                class="custom-input"
                @input="handleNameInput"
                name="user_name"
              ></el-input>
              <p v-if="addressForm.errors.user_name" class="error-tip">
                {{ addressForm.errors.user_name }}
              </p>
            </el-form-item>

            <!-- 手机号 -->
            <el-form-item
              label="手机号"
              class="form-item-with-line"
              :show-message="false"
              label-width="100px"
            >
              <el-input
                v-model="addressForm.user_phone"
                placeholder="填写联系电话"
                maxlength="11"
                class="custom-input"
                @input="formatPhone"
                name="user_phone"
              ></el-input>
              <p v-if="addressForm.errors.user_phone" class="error-tip">
                {{ addressForm.errors.user_phone }}
              </p>
            </el-form-item>
          </el-form>
        </div>

        <el-button
          type="info"
          plain
          @click="handleSave"
          :disabled="!validateForm()"
          class="save-button"
          >提交</el-button
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, onMounted } from "vue";
import KyIcon from "@/components/KyIcon";

const props = defineProps({
  isInfoShow: {
    type: Boolean,
    default: false,
  },
  infoParams: {
    type: Object,
    default: () => ({
      user_name: "",
      user_address: "",
      user_phone: "",
      city: "",
    }),
  },
});

const emit = defineEmits(["close", "save"]);

// 地址表单数据
const addressForm = ref({
  user_name: "",
  user_phone: "",
  city: "",
  user_address: "",
  // 错误信息存储
  errors: {
    user_name: "",
    user_phone: "",
    city: "",
    user_address: "",
  },
});

// 地区选择器选项
const areaOptions = ref([
  { label: "黄浦区", value: "黄浦区" },
  { label: "徐汇区", value: "徐汇区" },
  { label: "长宁区", value: "长宁区" },
  { label: "静安区", value: "静安区" },
  { label: "普陀区", value: "普陀区" },
  { label: "虹口区", value: "虹口区" },
  { label: "杨浦区", value: "杨浦区" },
  { label: "闵行区", value: "闵行区" },
  { label: "宝山区", value: "宝山区" },
  { label: "嘉定区", value: "嘉定区" },
  { label: "浦东新区", value: "浦东新区" },
  { label: "金山区", value: "金山区" },
  { label: "松江区", value: "松江区" },
  { label: "青浦区", value: "青浦区" },
  { label: "奉贤区", value: "奉贤区" },
  { label: "崇明区", value: "崇明区" },
]);

const validateName = () => {
  if (!addressForm.value.user_name.trim()) {
    addressForm.value.errors.user_name = "请输入收货人姓名";
    return false;
  }
  if (addressForm.value.user_name.length > 10) {
    addressForm.value.errors.user_name = "姓名不能超过10个字符";
    return false;
  }
  addressForm.value.errors.user_name = "";
  return true;
};

// 验证手机号
const validatePhone = () => {
  const phone = addressForm.value.user_phone;
  if (!phone) {
    addressForm.value.errors.user_phone = "请输入手机号";
    return false;
  }
  const phoneReg = /^1[3-9]\d{9}$/;
  if (!phoneReg.test(phone)) {
    addressForm.value.errors.user_phone = "请输入有效的11位手机号";
    return false;
  }
  addressForm.value.errors.user_phone = "";
  return true;
};

// 验证地区
const validateCity = () => {
  if (!addressForm.value.city) {
    addressForm.value.errors.city = "请选择所在地区";
    return false;
  }
  addressForm.value.errors.city = "";
  return true;
};

// 验证详细地址
const validateAddress = () => {
  if (!addressForm.value.user_address.trim()) {
    addressForm.value.errors.user_address = "请输入详细地址";
    return false;
  }
  if (addressForm.value.user_address.length < 5) {
    addressForm.value.errors.user_address = "详细地址不能少于5个字符";
    return false;
  }
  addressForm.value.errors.user_address = "";
  return true;
};

// 整体表单验证（触发所有验证）
const validateForm = () => {
  const isNameValid = validateName();
  const isPhoneValid = validatePhone();
  const isCityValid = validateCity();
  const isAddressValid = validateAddress();
  return isNameValid && isPhoneValid && isCityValid && isAddressValid;
};

// 格式化手机号并实时验证
const formatPhone = (value) => {
  // 去除所有非数字字符
  const pureNumber = value.replace(/\D/g, "");
  // 限制最大长度为11位
  const formattedPhone = pureNumber.slice(0, 11);
  addressForm.value.user_phone = formattedPhone;
  // 实时验证
  validatePhone();
};

// 填充表单数据（编辑场景）
const fillFormData = (info) => {
  addressForm.value = {
    ...addressForm.value, // 保留errors字段
    city: info.city || "",
    user_address: info.user_address || "",
    user_name: info.user_name || "",
    user_phone: info.user_phone || "",
  };
  // 填充后触发一次验证
  validateForm();
};

// 地区选择变化时验证
const handleAreaChange = (value) => {
  addressForm.value.city = value[0];
  validateCity();
};

// 输入姓名时实时验证
const handleNameInput = () => {
  validateName();
};

// 输入详细地址时实时验证
const handleAddressInput = () => {
  validateAddress();
};

// 关闭弹窗
const handleClose = () => {
  emit("close");
};

// 保存地址
const handleSave = () => {
  // 执行完整验证
  if (!validateForm()) {
    // 自动滚动到第一个错误项（可选）
    const firstErrorField = Object.keys(addressForm.value.errors).find(
      (key) => addressForm.value.errors[key]
    );
    if (firstErrorField) {
      document
        .querySelector(`[name="${firstErrorField}"]`)
        .scrollIntoView({ behavior: "smooth" });
    }
    return;
  }

  // 处理保存逻辑
  const addressData = {
    city: addressForm.value.city,
    user_address: addressForm.value.user_address,
    user_name: addressForm.value.user_name,
    user_phone: addressForm.value.user_phone,
  };

  // 提交地址数据给父组件
  emit("save", addressData);

  // 关闭弹窗
  handleClose();
};

onMounted(() => {
  try {
    // 从 localStorage 读取 infoParams
    const storedInfo = localStorage.getItem("infoParams");
    if (storedInfo) {
      const parsedInfo = JSON.parse(storedInfo); // 解析 JSON 字符串
      // 验证解析后的数据是否有效（确保包含必要字段）
      if (parsedInfo && typeof parsedInfo === "object") {
        fillFormData(parsedInfo); // 填充到表单
      }
    }
  } catch (err) {
    console.error("读取 localStorage 中的 infoParams 失败：", err);
    // 出错时不处理，保持表单默认空值
  }
});

watch(
  () => props.infoParams,
  (val) => {
    if (val && Object.keys(val).length > 0) {
      fillFormData(val);
    }
  },
  { immediate: true }
);
</script>
<style scoped lang="less">
.form-item-with-line {
  position: relative;
  margin-bottom: 0;
  border-bottom: 1px solid #eee;
}

:deep(.el-input__wrapper) {
  padding: 1px 0px;
}

.custom-input {
  width: 100%;
}

:deep(.custom-input .el-input__wrapper) {
  box-shadow: none !important;
}

:deep(.custom-input .el-input__inner),
:deep(.custom-cascader .el-cascader__input) {
  height: 44px !important;
  padding: 0 8px !important;
  font-size: 16px;
  box-shadow: none !important;
}

:deep(.custom-cascader .el-cascader__icon) {
  top: 14px !important;
}

:deep(.form-item-with-line .el-form-item__label) {
  height: 44px;
  line-height: 44px;
  padding-right: 16px;
  font-size: 16px;
}

.address-edit-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 100001;
}

.address-edit-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

/* 弹窗内容 */
.address-popup {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 0 20px;
  gap: 20px;
}

/* 头部 */
.popup-header {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 24px;
}

.close-btn {
  position: absolute;
  top: 20px;
  left: 20px;
  font-size: 24px;
  background: none;
  border: none;
  padding: 5px;
  cursor: pointer;
  color: #333;
}

.title {
  font-size: 22px;
  color: #333;
  margin: 0;
}

.form-container {
  width: 100%;
}

.save-button {
  width: 40%;
  padding: 20px 0;
  background-color: #f56c6c;
  color: #fff;
  font-size: 16px;
  border: none;
}

.error-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-bottom: 5px;
  padding-left: 8px;
  text-align: left;
  opacity: 1;
  transition: opacity 0.2s ease;
  line-height: 1;
  word-break: break-all;
  overflow: hidden;
}
</style>
